<template>
  <div class="classesBox fullWidth">
    <div class="loginFullScreen" v-if="false"></div>
    <custom-date-picker
      element="startDate"
      v-model="startDate"
      :show="startDatePopup"
      range
      type="date"/>
    <custom-date-picker
      element="endDate"
      v-model="endDate"
      :show="endDatePopup"
      type="date"/>
      <!-- H  E  A  D  E  R -->
    <div class="header primary fRow jaStart aCenter">
      <a :href="appName.site" :class="`${appName.name}Logo centerContain`"></a>
      <div class="item fRow jStart aCenter"
        @click="goToHome()">
        <i class="material-icons-round">home</i>
        <label>بازگشت به خانه</label>
      </div>
    </div>
    <!-- C O N T A I N E R -->
    <div class="classesHolder block fullWidth fCol jStart aStart">
      <div class="fRow jStart aCenter fullWidth filter wrap">
        <div class="filterHead fullWidth fRow jStart aCenter">
          <i class="material-icons-round">date_range</i>
          <div class="fCol jCenter aStart growFull">
            <div class="filterTitle fullWidth">تاریخ برگزاری</div>
            <div class="filterDesc fullWidth">برای مشاهده‌‌ی کلاس ها تاریخ برگزاری
              را انتخاب کنید
            </div>
          </div>
        </div>
        <div class="rol fRow jStart aCenter">
          <btn :fab="false"
            :mini="true"
            ic="schedule"
            label="امروز"
            @click.native="selectedDate = 1"
            :flat="selectedDate !== 1"/>
        </div>
        <div class="rol fRow jStart aCenter">
          <btn :fab="false"
            :mini="true"
            ic="date_range"
            label="فردا"
            @click.native="selectedDate = 2"
            :flat="selectedDate !== 2"/>
        </div>
        <div class="rol fRow jStart aCenter dateRol">
          <btn :fab="false"
            :mini="true"
            ic="date_range"
            @click.native="startDatePopup = true"
            :label="startDateShow"
            :flat="startDate === '' || selectedDate !== 3"/>
          <!-- <span class="to">←</span>
          <btn :fab="false"
            :mini="true"
            ic="date_range"
            @click.native="endDatePopup = true"
            :label="endDateShow"
            :flat="endDate === ''"/> -->
        </div>
        <div class="rol fRow jEnd aCenter growFull">
          <btn :fab="false"
            :mini="true"
            :fav="true"
            ic="search"
            @click.native="getClasses"
            label="جستجو"
            :flat="false"/>
          <btn :fab="!mobileMode"
            :mini="true"
            :fav="true"
            ic="close"
            @click.native="clearExactDate"
            label="حذف فیلتر"
            class="clearFilter"
            mode="error"
            :flat="endDate === '' && startDate === ''"/>
        </div>
      </div>
      <!-- lists -->
      <div class="classes fullWidth fCol jStart aCenter">
        <div class="month fullWidth">
          <div class="monthHead fullWidth fRow jStart aCenter">
            <i class="material-icons-round headIcon">date_range</i>
            <div class="fCol jCenter aStart growFull">
              <div class="monthName fu6llWidth">{{groupHeadTitle()}}</div>
              <div class="classCount" v-if="!loading">{{classes.length}} جلسه کلاس</div>
              <div class="classCount" v-if="loading">لطفا کمی صبر کنید...</div>
            </div>
            <i class="material-icons-round expand">keyboard_arrow_down</i>
          </div>
          <!-- loading -->
          <div class="fCol jCenter aCenter fullWidth" v-if="!loaded">
            <!-- v-if="loading || noContent"> -->
            <p-bar
              :loading="loading"
              :notYet="notYet"
              :noContent="noContent"
              :notFound="notFound"
              :mini="true"
              :error="error" />
          </div>
          <div class="class fullWidth fRow jBetween aCenter wrap"
            v-for="(item, index) in classes" v-bind:key="index">
            <div class="fRow jStart aCenter classInfos">
              <div class="lessonAvatar"
                v-bind:style="{backgroundImage: `url('https://api.${appName.name}.ir/${item.lesson.photo}')`}"></div>
              <div class="classInfo fRow jBetween aCenter wrap fullWidth">
                <div class="className fullWidth">{{item.name}}
                  <div class="badge"
                    v-bind:class="{
                      now: checkDate(item.startAt, item.duration).status === 'now',
                      today: checkDate(item.startAt, item.duration).status === 'future'
                        && checkDate(item.startAt, item.duration).today,
                      future: checkDate(item.startAt, item.duration).status === 'future'
                        && !checkDate(item.startAt, item.duration).today,
                      passed: checkDate(item.startAt, item.duration).status === 'passed',
                    }">{{checkDate(item.startAt, item.duration).title}}</div>
                </div>
                <div class="fRow fullWidth jStart aCenter" style="margin-bottom: 4px">
                  <div class="lessonName fRow jCenter aCenter">
                    <i class="material-icons-round">menu_book</i>
                    {{item.lesson.title}}</div>
                  <div class="teacherName fRow jCenter aCenter">
                    <i class="material-icons-round">school</i>
                    {{item.teacherFullName}}
                  </div>
                </div>
                <div class="fullWidth classDateTime fRow jStart aCenter">
                  <i class="material-icons-round">date_range</i>
                  {{formatDate(item.startAt).date}}
                </div>
                <div class="fullWidth classDateTime fRow jStart aCenter">
                  <i class="material-icons-round">schedule</i>
                  از ساعت {{formatDate(item.startAt).time}}
                  تا {{datePlusDuration(item.startAt, item.duration)}}
                </div>
              </div>
            </div>
            <!-- future options -->
            <div class="classActions fRow jEnd aStart wrap growFull"
              v-if="checkDate(item.startAt, item.duration).status === 'future'">
              <btn :fab="false"
                :mini="true"
                :flat="true"
                ic="date_range"
                :label="checkDate(item.startAt, item.duration).title"/>
            </div>
            <!-- now options -->
            <div class="classActions fRow jEnd aStart wrap growFull"
              v-if="checkDate(item.startAt, item.duration).status === 'now'">
              <btn :fab="false"
                mode="success"
                ic="login"
                label="ورود به کلاس"
                @click.native="joinClass(item.id)"/>
            </div>
            <!-- passed options -->
            <div class="classActions fRow jEnd aStart wrap growFull"
              v-if="checkDate(item.startAt, item.duration).status === 'passed'">
              <btn :fab="false"
                :mini="true"
                :flat="true"
                mode="info"
                ic="videocam"
                label="مشاهدۀ ویدیو"
                @click.native="joinClass(item.id)"/>
            </div>
            <!-- files -->
            <div class="fullWidth fRow jStart aStart files wrap">
              <div class="title fullWidth fRow jBetween aCenter">
                فایل های مربوط به کلاس {{item.name}} ({{item.files.length}} فایل)
                <div class="editBtn fRow jStart aCenter mini flat"
                  @click="goEditFiles(item.id)"
                  v-if="canEdit === 'Teacher'">
                  <i class="material-icons-round">edit</i>
                  <label>ویرایش فایل‌ها</label>
                </div>
              </div>
              <a v-for="(file, indx) in item.files"
                v-bind:key="indx"
                class="fRow jStart aCenter transition-fast"
                :href="`https://api.${appName.name}.ir/files/${file.id}${file.extensions}`"
                download="file">
                <i class="material-icons-round get">get_app</i>
                <div class="fCol growFull jCenter aStart">
                  <div class="fileName">{{file.name}}{{file.extensions}}</div>
                  <div class="fileSize">{{fixStorageSize(file.size)}}</div>
                </div>
              </a>
              <div class="noFiles fullWidth fRow jStart aCenter"
                v-if="item.files.length === 0">
                فایلی برای این کلاس ثبت نشده
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBar fCol jCenter aCenter">
      <a :href="appName.site" :class="`typo ${appName.name}`"></a>
      <span>کلیه حقوق متعلق به {{appName.faName}} می‌باشد</span>
    </div>
    <div class="modal fCol jCenter aCenter" v-if="modal">
      <div class="closer" @click="modal = false"></div>
      <div class="modalBox">
        <!-- مدیریت فایلها  -->
        <div class="uploadersHolder fullWidth fRow jBetween aStart">
          <div class="w60 fCol jStart aStart">
            <file-uploader
              @activeUploaders="activeFileUploaders = true"
              @refreshFiles="getClassFiles"
              :classId="classId" />
          </div>
          <div class="w40 fCol jStart aStart list">
            <h3 class="fRow jStart aCenter secondary fullWidth">
              <i class="material-icons-round">attachment</i>
              فایل‌های ثبت شده برای این کلاس</h3>
            <div class="fCol jCenter aCenter fullWidth"
              v-if="!loaded">
              <p-bar
                :loading="loading"
                :notYet="notYet"
                :noContent="noContent"
                :notFound="notFound"
                :error="error" />
            </div>
            <ul class="growFull fullWidth" v-if="loaded">
              <li class="fullWidth fRow jStart aCenter"
                v-for="(item, index) in courseFiles" v-bind:key="index">
                <div class="rad">{{index + 1}}</div>
                <span class="growFull">{{item.name}}</span>
                <i class="material-icons-round delete"
                  @click="deleteCourseFile(classId, item.id)">delete</i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Btn from '@/components/Btn.vue';
import Moment from 'moment-jalaali';
import pBar from '@/components/pBar.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import FileUploader from '@/components/ClassFileUploader.vue';

export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      // 1 : today • 2 : tommorow
      // 3 : all • 4 : exact
      baseURL: '',
      V: 1,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: true,
      loaded: true,
      modeMsg: '',
      // modes ↑
      selectedDate: 0,
      startDate: '',
      startDatePopup: false,
      startDateShow: 'انتخاب بازۀ زمانی',
      endDate: '',
      endDatePopup: false,
      endDateShow: 'تا تاریخ ...',
      mobileMode: false,
      classes: [],
      classess: [
        {
          id: 'f54684s684f68468s468d4',
          name: 'کلاس شماره یک',
          startAt: '2022-05-09T18:00',
          duration: 180,
          lesson: {
            title: 'ریاضی سوم تجربی',
            photo: '61d46e44af52baab511e41c8.jpg',
          },
          teacherFullName: 'دبیر تست پشتیبانی',
          files: [
            {
              title: 'فایل یک',
              url: 'ashdkajdhakdj.pdf',
              size: '256213',
            },
            {
              title: 'فایل دو',
              url: 'ashdkajdhakdj.pdf',
              size: '256213',
            },
            {
              title: 'فایل سه',
              url: 'ashdkajdhakdj.pdf',
              size: '256213',
            },
          ],
        },
        {
          id: 'f54684s6sad4f68468s468d4',
          name: 'کلاس شماره دو',
          startAt: '2022-05-09T19:00',
          duration: 60,
          lesson: {
            title: 'زیست سوم تجربی',
            photo: '61d4671caf52baab511e4109.jpg',
          },
          teacherFullName: 'دبیر تست پشتیبانی',
          files: [
            {
              title: 'فایل یک',
              url: 'ashdkajdhakdj.pdf',
              size: '256213',
            },
            {
              title: 'فایل دو',
              url: 'ashdkajdhakdj.pdf',
              size: '256213',
            },
          ],
        },
      ],
      today: '',
      tomorrow: '',
      sd: '',
      ed: '',
      modal: false,
      classId: '',
      canEdit: '',
    };
  },
  methods: {
    deleteCourseFile(classId, fileId) {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/file/${classId}/${fileId}`;
      axios({
        method: 'delete',
        url: reqUrl,
        headers: {
          Authorization: this.token,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.makeToast('success', 'فایل با موفقیت حذف شد', 3000);
          this.getClassFiles();
        } else {
          this.makeToast('warning', 'خطا در حذف فایل', 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      }).catch(() => {
        this.makeToast('error', 'خطای ناشناخته، لطفا اتصال به اینترنت را بررسی کنید', 3000);
      });
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    goEditFiles(id) {
      this.modal = true;
      console.clear();
      console.log(id);
      this.classId = id;
      this.getClassFiles();
    },
    goToHome() {
      this.$router.push('/');
    },
    clearExactDate() {
      this.startDate = '';
      this.endDate = '';
      this.selectedDate = 1;
    },
    screenInit() {
      const w = window.innerWidth;
      if (w <= 500) {
        this.mobileMode = true;
      } else {
        this.mobileMode = false;
      }
    },
    // get classes
    getClasses() {
      this.classes = [];
      this.setMode('loading');
      this.startDatePopup = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/classes?startAt=${this.sd}&endAt=${this.ed}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: `bearer ${localStorage.getItem('user').replace(/"/g, '')}`,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.setMode('loaded');
          const r = response.data.data;
          if (r.length > 0) {
            this.classes = r;
            this.setMode('loaded');
          } else {
            this.setMode('noContent');
          }
        } else {
          this.setMode('error', response.data.message);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'خطای فنی');
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    // check classes by time and date
    checkDate(date, duration) {
      const classDateRange = {
        start: date,
        end: Moment(date, 'YYYY-MM-DDTHH:mm:ss')
          .locale('en')
          .add(duration, 'm')
          .format('YYYY-MM-DDTHH:mm:ss'),
      };
      // momentize datas ↓
      const now = Moment(new Date());
      const s = Moment(classDateRange.start);
      const e = Moment(classDateRange.end);
      // calculate diffs
      const diffStart = now.diff(s);
      const diffEnd = now.diff(e);
      let finalCheck = '';
      let label = '';
      let isToday = false;
      if (diffStart > 0 && diffEnd > 0) {
        finalCheck = 'passed';
        label = now.diff(s, 'days');
        if (label === 0) {
          isToday = true;
          label = now.diff(s, 'hours');
          if (label === 0) {
            label = now.diff(s, 'minutes');
            label += ' دقیقه پیش';
          } else {
            label += ' ساعت پیش';
          }
        } else if (label === 1) {
          label = 'دیروز';
        } else {
          label += ' روز پیش';
        }
      }
      if (diffStart > 0 && diffEnd < 0) {
        isToday = true;
        finalCheck = 'now';
        label = 'در حال برگزاری';
      }
      if (diffStart < 0 && diffEnd < 0) {
        finalCheck = 'future';
        label = e.diff(now, 'days');
        if (label === 0) {
          isToday = true;
          label = s.diff(now, 'hours');
          if (label === 0) {
            label = s.diff(now, 'minutes');
            label += ' دقیقه دیگر';
          } else {
            label += ' ساعت دیگر';
          }
        } else if (label === 1) {
          label = 'فردا';
        } else {
          label += ' روز دیگر';
        }
      }
      return {
        status: finalCheck,
        title: label,
        today: isToday,
      };
    },
    // join classes
    joinClass(u) {
      // this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/join/${u}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: `bearer ${localStorage.getItem('user').replace(/"/g, '')}`,
        },
        // data: {
        //   meetingId: u,
        // },
      }).then((response) => {
        if (response.data.isSuccess) {
          // this.setMode('loaded');
          const r = response.data.data;
          if (r.length > 0) {
            // this.getClassResult = r;
          } else {
            // this.setMode('noContent');
          }
        } else {
          // this.setMode('error', response.data.message);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        // this.setMode('error', 'خطای فنی');
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    // format date
    formatDate(d) {
      const a = {
        time: '',
        date: '',
      };
      a.time = Moment(d, 'YYYY-MM-DDTHH:mm:ss')
        .locale('fa')
        .format('HH:mm');
      a.date = Moment(d, 'YYYY-MM-DDTHH:mm:ss')
        .locale('fa')
        .format('jDD jMMMM jYYYY');
      return a;
    },
    datePlusDuration(d, duration) {
      const final = Moment(d, 'YYYY-MM-DDTHH:mm:ss')
        .add(duration, 'm')
        .format('HH:mm');
      return final;
    },
    groupHeadTitle() {
      let a = '';
      switch (this.selectedDate) {
        case 1: {
          a = Moment(this.today, 'YYYY-MM-DD')
            .locale('fa')
            .format('امروز: dddd, jDD jMMMM jYYYY');
          break;
        }
        case 2: {
          a = Moment(this.tomorrow, 'YYYY-MM-DD')
            .locale('fa')
            .format('فردا: dddd, jDD jMMMM jYYYY');
          break;
        }
        case 3: {
          a = Moment(this.sd, 'YYYY-MM-DD')
            .locale('fa')
            .format('از jDD jMMMM jYYYY ');
          a += Moment(this.ed, 'YYYY-MM-DD')
            .locale('fa')
            .format('تا jDD jMMMM jYYYY ');
          break;
        }
        default:
          break;
      }
      return a;
    },
    fixStorageSize(s) {
      let unit = '';
      let size = s;
      if (size > 1073741823) {
        size = (size / 1073741824).toFixed(1);
        unit = 'GB';
      } else if (size > 1048575) {
        size = (size / 1048576).toFixed(0);
        unit = 'MB';
      } else if (size > 1023 && size < 1048575) {
        size = (size / 1024).toFixed(1);
        unit = 'KB';
      } else {
        unit = 'B';
      }
      return `${size}${unit}`;
    },
    getClassFiles() {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Classes/files/${this.classId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.token,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.courseFiles = response.data.data;
          if (this.courseFiles.length === 0) {
            this.setMode('noContent');
          } else {
            this.setMode('loaded');
            this.classFiles = response.data.data;
          }
        } else {
          this.setMode('error', 'مشکلی پیش آمده است');
        }
      }, (error) => {
        this.setMode('error', this.errorHandler(error));
      }).catch(() => {
        this.setMode('error', 'خطای ناشناخته، لطفا اتصال به اینترنت را بررسی کنید');
      });
    },
  },
  components: {
    Btn,
    pBar,
    FileUploader,
  },
  watch: {
    modal() {
      if (!this.modal) {
        this.classId = '';
        this.getClasses();
      }
    },
    startDate() {
      this.startDatePopup = false;
      if (this.startDate === '') {
        this.startDateShow = 'انتخاب بازۀ زمانی';
      } else {
        this.selectedDate = 3;
        this.classes = [];
        this.getClasses();
        this.startDateShow = Moment(this.startDate[0], 'YYYY-MM-DDT00:00')
          .locale('fa')
          .format('jDD jMMMM jYYYY --> ');
        this.startDateShow += Moment(this.startDate[1], 'YYYY-MM-DDT00:00')
          .locale('fa')
          .format('jDD jMMMM jYYYY');
      }
    },
    endDate() {
      this.endDatePopup = false;
      if (this.endDate === '') {
        this.endDateShow = 'تا تاریخ ...';
      } else {
        this.selectedDate = 4;
        this.endDateShow = Moment(this.endDate, 'YYYY-MM-DDT00:00')
          .locale('fa')
          .format('تا  jDD jMMMM jYYYY');
      }
    },
    selectedDate() {
      this.classes = [];
      switch (this.selectedDate) {
        case 1: {
          this.sd = `${this.today}T00:00:00`;
          this.ed = `${this.today}T23:59:59`;
          break;
        }
        case 2: {
          this.sd = `${this.tomorrow}T00:00:00`;
          this.ed = `${this.tomorrow}T23:59:59`;
          break;
        }
        case 3: {
          this.sd = `${this.startDate[0]}00:00:00`;
          this.ed = `${this.startDate[1]}23:59:00`;
          break;
        }
        default:
          break;
      }
      this.getClasses();
    },
  },
  computed: {
    appName() {
      return this.$store.state.appName;
    },
    isTeacher() {
      return this.$store.state.isTeacher;
    },
    token() {
      return `bearer ${localStorage.getItem('user').replace(/"/g, '')}`;
    },
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.screenInit();
      });
    });
  },
  mounted() {
    this.$nextTick(() => {
      // check if teacher
      const u = this.$jwt.decode(JSON.parse(localStorage.getItem('user')));
      this.canEdit = u.UserType;
      // then
      const d = new Date();
      this.today = Moment(d).locale('en').format('yyyy-MM-DD');
      this.tomorrow = Moment(d).add(1, 'd').locale('en').format('yyyy-MM-DD');
      this.selectedDate = 1;
      this.baseURL = this.appName.url;
      this.getClasses();
    });
  },
};
</script>

<style lang="scss" scoped>
.classesBox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden auto;
  .bottomBar {
    padding: 64px;
    a.typo {
      width: 64px;
      height: 64px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      text-decoration: none;
      margin-bottom: 8px;
    }
    .typo.rimik {
      background-image: url('~@/assets/rimikdark.svg');
    }
    .typo.verta {
      background-image: url('~@/assets/vertadark.svg');
    }
    span {
      font-size: 10px;
      color: var(--primary);
    }
  }
  .loginFullScreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    backdrop-filter: blur(16px);
    background-color: var(--normalText35);
    z-index: 500000;
  }
}
.block {
  padding: 24px 308px;
}
.classesHolder {
  .filter {
    padding: 8px;
    border-radius: 24px;
    border: solid 1px var(--primary15);
    .filterHead {
      margin-bottom: 16px;
      i {
        font-size: 32px;
        margin-left: 8px;
        padding: 8px;
        border-radius: 50%;
        background-color: var(--primary15);
      }
      .filterTitle {
        font-size: 16px;
        font-weight: 300;
        color: var(--normalText);
        text-align: right;
      }
      .filterDesc {
        font-size: 12px;
        font-weight: 300;
        color: var(--normalText);
        text-align: right;
      }
    }
    .rol {
      padding: 4px;
      border-radius: 24px;
      margin-left: 8px;
      background-color: var(--normalText05);
    }
    .dateRol {
      .button {
        // margin-left: 8px;
      }
      .to {
        margin: 0 4px;
      }
      .clearFilter {
        margin: 0 0 0 4px !important;
      }
    }
  }
  .classes {
    padding: 8px;
    margin-top: 16px;
    border-radius: 24px 24px 8px 8px;
    border: solid 1px var(--primary15);
    .month {
      .monthHead {
        padding: 8px 8px 16px 8px;
        border-bottom: solid var(--primary25) 1px;
        box-shadow: 0 12px 8px -8px rgba($color: #000000, $alpha: 0.15);
        margin-bottom: 16px;
        i.headIcon {
          font-size: 16px;
          padding: 8px;
          border-radius: 50%;
          background-color: rgba($color: #000000, $alpha: 0.05);
          margin-left: 8px;
        }
        .monthName {
          font-size: 14px;
          font-weight: bold;
          line-height: 1;
          color: var(--primary);
        }
        .classCount {
          font-size: 12px;
          margin-top: 4px;
          line-height: 1;
          color: var(--normalText5);
        }
      }
      .class {
        padding: 8px;
        border-radius: 16px;
        margin-bottom: 12px;
        border: solid 4px;
        border-color: var(--normalText15);
        box-shadow: 0 12px 16px -16px rgba($color: #000000, $alpha: 0.35);
        .classInfos {
          .classInfo {
            .className {
              font-weight: bold;
              font-size: 16px;
              padding-right: 4px;
              color: var(--normalText);
              text-align: right;
              margin-bottom: 4px;
              margin-left: 8px;
              .badge {
                display: inline;
                white-space: nowrap;
                padding: 2px 6px;
                font-size: 8px !important;
                border-radius: 24px;
              }
              .badge.now {
                @keyframes nowAnimation {
                  0% {
                    box-shadow: 0 0 0 0 var(--themeOrange);
                  }
                  100% {
                    box-shadow: 0 0 0 16px var(--themeRed0);
                  }
                }
                background-color: var(--themeOrange);
                color: var(--themeWhite);
                font-weight: bold;
                animation: nowAnimation 1s cubic-bezier(1,0,0,1) infinite alternate;
              }
              .badge.passed {
                background-color: var(--gray5);
                color: var(--themeWhite);
              }
              .badge.future {
                background-color: var(--themeBlue);
                color: var(--themeWhite);
              }
              .badge.today {
                background-color: var(--themeGreen);
                color: var(--themeWhite);
              }
            }
            .lessonName {
              font-size: 10px;
              padding: 4px 8px;
              border-radius: 24px;
              background-color: var(--secondary);
              color: var(--themeWhite);
              margin-left: 8px;
              i {
                font-size: 12px;
                margin-left: 4px;
                color: var(--themeWhite7);
              }
            }
            .teacherName {
              font-size: 12px;
              padding: 4px 8px;
              border-radius: 24px;
              color: var(--normalText);
              i {
                font-size: 12px;
                margin-left: 4px;
                color: var(--normalText8);
              }
            }
            .classDateTime {
              font-size: 12px;
              font-weight: bold;
              padding: 4px 6px;
              border-right: solid 4px var(--primary35);
              color: var(--normalText7);
              i {
                font-size: 16px;
                margin-left: 8px;
                color: var(--normalText5);
              }
            }
          }
          .lessonAvatar {
            border-radius: 50%;
            $www: 128px;
            width: $www;
            height: $www;
            min-width: $www;
            margin-left: 16px;
            background-color: var(--normalText05);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            box-shadow: 0 16px 16px -12px var(--themeBlack5);
          }
        }
        .classActions {
          background-color: var(--primary0);
          border-top: dashed 2px var(--normalText25);
          padding: 8px 8px 0 8px;
          margin-top: 8px;
        }
        .files {
          border-top: dashed 1px var(--normalText15);
          padding: 16px;
          margin: 16px 0 0px 0;
          .title {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 8px;
            .editBtn {
              border-radius: 16px;
              padding: 4px 8px;
              border-radius: 16px;
              cursor: pointer;
              background-color: var(--themeBlue15);
              * {
                pointer-events: none;
              }
              label {
                font-size: 12px;
                color: var(--normalText);
              }
              i {
                color: var(--normalText);
                margin-left: 4px;
                font-size: 16px;
              }
            }
          }
          a {
            text-decoration: none;
            padding: 8px;
            border-radius: 8px;
            margin-left: 8px;
            margin-top: 8px;
            min-width: 45%;
            background-color: var(--themeSurface);
            box-shadow: 0 8px 12px -8px var(--themeBlack2);
            color: var(--normalText);
            * {
              pointer-events: none;
            }
            i.get {
              font-size: 24px;
              margin-left: 8px;
              color: var(--primary);
            }
            .fileName {
              font-size: 14px;
              margin-bottom: 4px;
              line-height: 1;
            }
            .fileSize {
              font-size: 10px;
              line-height: 1;
            }
          }
          .noFiles {
            font-size: 14px;
            color: var(--normalText45);
          }
        }
      }
      .class:nth-child(odd) {
        border-color: var(--normalText25);
      }
      .class:last-child {
        margin-bottom: 0 !important;
      }
    }
  }
}
.modal {
  position: fixed;
  z-index: 90000000000;
  background-color: var(--themeBlack7);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  .closer {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
  }
  .modalBox {
    background-color: var(--themeBackground);
    padding: 16px;
    border-radius: 0 16px 16px 0;
    z-index: 20;
    width: 90%;
    max-width: 1200px;
    height: 90vh;
    overflow: hidden auto;
  }
}
.list {
  border-radius: 8px;
  overflow: hidden;
  height: 450px;
  box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
  h3 {
    font-size: 12px;
    font-weight: 300;
    text-align: right;
    color: white;
    padding: 8px;
    margin: 0;
    border-bottom: solid 1px rgba($color: #000000, $alpha: 0.15);
    i {
      font-size: 16px;
      margin-left: 8px;
      color: rgba($color: white, $alpha: 0.70);
    }
  }
  ul {
    padding: 0;
    margin: 0;
    overflow: hidden auto;
    li {
      list-style: none;
      padding: 8px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
      .rad {
        font-size: 10px;
        text-align: right;
        width: 24px;
      }
      span {
        font-size: 12px;
        font-weight: 200;
        color: #131313;
        text-align: right;
      }
      i.delete {
        font-size: 16px;
        padding: 4px;
        border-radius: 50%;
        margin-right: 8px;
        cursor: pointer;
        color: white;
        background-color: rgba($color: #b43838, $alpha: 0.8);
      }
    }
    li:hover {
      background-color: rgba($color: #000000, $alpha: 0.01);
    }
  }
}

// responsive

@media only screen and (max-width: 500px) {
  .classes {
    max-height: 100vh;
    overflow: hidden auto;
    .block {
      padding: 24px 16px;
    }
    .rol {
      width: calc(50% - 8px);
      .button {
        width: 100%;
        margin-left: 0;
      }
    }
    .dateRol {
      margin-top: 4px;
      width: 100%;
      .button {
        width: unset !important;
        flex-grow: 0.5;
        margin-left: 0 !important;
      }
    }
    .classInfos {
      width: 100%;
    }
    .classActions {
      width: 100%;
    }
  }
}

@media only screen and (max-width: 800px) and (min-width: 500px) {
  .block {
    padding: 24px 24px;
  }
  .classInfos {
    width: 100%;
  }
  .classActions {
    width: 100%;
  }
}

@media only screen and (max-width: 1145px) and (min-width: 800px) {
  .block {
    padding: 24px 112px;
  }
  .classInfos {
    width: calc(70% - 8px);
  }
  .classActions {
    padding-top: 0 !important;
    border: none !important;
    margin-top: 0 !important;
  }
}

@media only screen and (max-width: 1400px) and (min-width: 1145px) {
  .block {
    padding: 24px 20%;
  }
  .classInfos {
    width: calc(70% - 8px);
  }
  .classActions {
    padding-top: 0 !important;
    border: none !important;
    margin-top: 0 !important;
  }
}

@media only screen and (min-width: 1400px) {
  .block {
    padding: 24px 15%;
  }
  .classInfos {
    width: calc(80% - 8px);
  }
  .classActions {
    padding-top: 0 !important;
    border: none !important;
    margin-top: 0 !important;
  }
}
</style>
